const C = {
    primary: "#0F6A71",
    primaryDark: "#0B4F54",
    primaryLight: "#D6EAE6",
    accent: "#FFC000",
    accentDark: "#C98A00",
    accentLight: "#FFE9AE",
    accentWarm: "#D4845A",
    accentWarmDark: "#B5663E",
    accentWarmLight: "#F4D2BC",
    danger: "#C0392B",
    dangerDark: "#922B21",
    dangerLight: "#FDE8E8",
    bg: "#FBF7EF",
    surface: "#FFFFFF",
    border: "rgba(36,57,56,0.10)",
    text: "#243938",
    textMuted: "#5E7472",
    green: "#0F6A71",
};

const styles = {
    page: {
        minHeight: "100vh",
        backgroundColor: C.bg,
        padding: 12,
        fontFamily: "'Public Sans', 'Segoe UI', Arial, sans-serif",
        color: C.text,
    },
    header: {
        position: "sticky", top: 0, zIndex: 100,
        backgroundColor: C.primary,
        color: "white",
        padding: "10px 20px",
        borderRadius: 12,
        marginBottom: 20,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
        gap: 12,
        flexWrap: "wrap",
    },
    logoZone: {display: "flex", alignItems: "center", gap: 16},
    logoBox: {
        width: 52, height: 52, borderRadius: 10,
        backgroundColor: "rgba(255,255,255,0.15)",
        border: "1.5px solid rgba(255,255,255,0.35)",
        color: "white",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontWeight: "700", fontSize: 13, textAlign: "center", letterSpacing: 0.5,
    },
    avatarCircle: {
        width: 38, height: 38, borderRadius: "50%",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: 16, color: "white", fontWeight: "bold",
        border: "2px solid rgba(255,255,255,0.6)",
    },
    layout: {maxWidth: 1280, margin: "auto", display: "flex", gap: 18, alignItems: "flex-start"},
    sidebar: {
        width: 300,
        backgroundColor: C.surface,
        padding: 18,
        borderRadius: 14,
        border: `1px solid ${C.border}`,
        boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
    },
    main: {
        flex: 1,
        backgroundColor: C.surface,
        padding: 24,
        borderRadius: 14,
        border: `1px solid ${C.border}`,
        boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
    },
    tabBar: {
        display: "flex", gap: 2, marginBottom: 8, flexWrap: "wrap",
        borderBottom: `2px solid #E2E4E0`,
        paddingBottom: 0,
    },
    card: {
        backgroundColor: C.surface,
        border: `1px solid ${C.border}`,
        padding: 16,
        marginBottom: 12,
        borderRadius: 12,
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    },
    input: {
        width: "100%",
        padding: "10px 12px",
        marginBottom: 10,
        borderRadius: 10,
        border: `1.5px solid ${C.border}`,
        boxSizing: "border-box",
        fontSize: 14,
        color: C.text,
        backgroundColor: "#FAFAF8",
        outline: "none",
        transition: "border-color 0.15s",
    },
    button: {
        backgroundColor: C.primaryLight,
        color: C.primary,
        border: `1px solid ${C.primary}33`,
        padding: "7px 16px",
        borderRadius: 10,
        cursor: "pointer",
        fontWeight: "600",
        fontSize: 13,
        whiteSpace: "nowrap",
        marginRight: 6,
        marginBottom: 4,
        transition: "background-color 0.15s, opacity 0.15s",
    },
    likeButton: {
        backgroundColor: C.accentWarmLight,
        color: C.accentWarmDark,
        border: `1px solid ${C.accentWarm}55`,
        padding: "7px 16px",
        borderRadius: 10,
        cursor: "pointer",
        fontWeight: "600",
        fontSize: 13,
        whiteSpace: "nowrap",
        marginRight: 6,
        marginBottom: 4,
        transition: "background-color 0.15s, opacity 0.15s",
    },
    primaryButton: {
        backgroundColor: C.primary,
        color: "white",
        border: "none",
        padding: "9px 20px",
        borderRadius: 10,
        cursor: "pointer",
        fontWeight: "600",
        fontSize: 14,
        transition: "background-color 0.15s",
    },
    dangerButton: {
        backgroundColor: C.dangerLight,
        color: C.danger,
        border: `1px solid ${C.danger}33`,
        padding: "6px 12px",
        borderRadius: 10,
        cursor: "pointer",
        fontWeight: "600",
        fontSize: 13,
        transition: "background-color 0.15s, color 0.15s",
    },
    warning: {
        backgroundColor: C.accentLight,
        border: `1px solid #F0C040`,
        padding: 12,
        borderRadius: 8,
        marginTop: 8,
        fontSize: 13,
    },
    adminBox: {
        backgroundColor: C.primaryLight,
        border: `1px solid ${C.primary}`,
        padding: 16,
        marginBottom: 16,
        borderRadius: 10,
    },
    bottomNav: {
        position: "fixed", bottom: 0, left: 0, right: 0,
        backgroundColor: C.surface,
        display: "flex", justifyContent: "space-around", alignItems: "stretch",
        paddingTop: 6,
        paddingBottom: "calc(6px + env(safe-area-inset-bottom))",
        borderTop: `1px solid ${C.border}`,
        boxShadow: "0 -2px 8px rgba(0,0,0,0.08)",
        zIndex: 999,
    },
    bottomNavItem: {
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
        gap: 2, flex: 1, minHeight: 44,
        background: "none", border: "none", cursor: "pointer",
        fontSize: 11, fontWeight: 600, color: C.textMuted,
        padding: "4px 0",
    },
    bottomNavItemActive: {
        color: C.primary,
    },
    bottomNavEmoji: {
        fontSize: 22,
        lineHeight: 1,
    },
};

export {C};
export default styles;
